<!--
 * @Author: your name
 * @Date: 2021-06-27 17:06:11
 * @LastEditTime: 2021-06-27 17:15:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\views\Im\components\product.vue
-->
<template>
    <div class="box">

    </div>
</template>

<script>
    export default{
        data(){

        },
        methods:{

        }
    }
</script>
<style scoped>
    .box{
        width: 666px;
        height: 500px;
        border: 1px solid rgb(48, 25, 255);
        z-index: 999999;
    }
</style>


// WEBPACK FOOTER //
// src/TASMini/views/Im/components/product.vue